/**
 * Hook pour gérer la connexion Socket.io
 * Compatible avec le serveur Socket.io existant
 */
import { useEffect, useState, useRef } from 'react';
import { io } from 'socket.io-client';
import { SOCKET_URL } from '../config/api';

// SOCKET_URL is now centralized in config/api.ts

export const useSocket = (token) => {
  const [socket, setSocket] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  const socketRef = useRef(null);

  useEffect(() => {
    if (!token) {
      console.warn('[useSocket] No token provided');
      return;
    }

    // Créer la connexion Socket.io
    const socketInstance = io(SOCKET_URL, {
      auth: {
        token: token
      },
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
    });

    socketInstance.on('connect', () => {
      console.log('[useSocket] ✅ Connected to Socket.io server');
      setIsConnected(true);
    });

    socketInstance.on('disconnect', () => {
      console.log('[useSocket] ❌ Disconnected from Socket.io server');
      setIsConnected(false);
    });

    socketInstance.on('connect_error', (error) => {
      console.error('[useSocket] Connection error:', error);
      setIsConnected(false);
    });

    socketRef.current = socketInstance;
    setSocket(socketInstance);

    return () => {
      if (socketInstance) {
        socketInstance.disconnect();
      }
    };
  }, [token]);

  return { socket, isConnected };
};

